import * as Long from "long";
import * as React from "react";
import { connect } from "react-redux";
import { selectBalancingOutskirt } from "../../balancingSelectors/selectBalancingOutskirts";
import { IdOutskirtBuildings } from "../../constants/IdOutskirtBuildings";
import { IdStyles } from "../../less/IdStyles";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { ReplacementLoca } from "../../utils/i18n/ReplacementLoca";
import { utilNumber } from "../../utils/utilNumber";
import { IconWithProgress } from "../generic/icon-with-progress/IconWithProgress";
import { IdIcon } from "../generic/icon/IdIcon";
import { NumberFormat } from "../generic/number-format/NumberFormat";
import { TooltipText } from "../tooltip";
var _MarketXp = function (_a) {
    var marketXp = _a.marketXp;
    var marketInfo = selectBalancingOutskirt(IdOutskirtBuildings.Market);
    if (marketXp && marketXp.stage) {
        var currentXp = marketXp.xp || Long.ZERO;
        var stage = marketXp.stage; // Initial value: 1
        var idLoca = IdLoca.maxLevelReached;
        var replacements = new Map();
        var progress = Long.fromInt(100);
        var currentStageInfo = marketInfo.outsideBuildingStage[stage - 1];
        var nextStageInfo = marketInfo.outsideBuildingStage[stage];
        if (nextStageInfo !== undefined) {
            var xpToNextStage = Long.ZERO;
            var currentStageXp = currentStageInfo && currentStageInfo.requiredXp ? currentStageInfo.requiredXp : 0;
            var nextStageXp = nextStageInfo && nextStageInfo.requiredXp ? nextStageInfo.requiredXp : 0;
            if (nextStageXp > 0) {
                progress = currentXp
                    .subtract(currentStageXp)
                    .multiply(100)
                    .divide(nextStageXp - currentStageXp);
                xpToNextStage = Long.fromValue(nextStageXp).subtract(currentXp);
                idLoca = IdLoca.floatingText_xplevelup;
                replacements.set(ReplacementLoca.zero_0, utilNumber.format(xpToNextStage));
            }
        }
        var iconText = (React.createElement(NumberFormat, { amount: stage || 0, className: IdStyles.TextBoldSecondaryOutline }));
        return (React.createElement("div", { className: "market-xp" },
            React.createElement(TooltipText, { id: idLoca, replacements: replacements },
                React.createElement(IconWithProgress, { progressPercent: progress.toNumber(), fillClassName: IdStyles.ProgressBarFill, backgroundClassName: IdStyles.ProgressBarBackground, icon: IdIcon.MarketXpIcn, iconStyle: IdStyles.IconLarge, iconTextComponent: iconText },
                    React.createElement(NumberFormat, { className: IdStyles.TextBoldSecondaryOutline, amount: currentXp })))));
    }
    return React.createElement(React.Fragment, null);
};
var mapState = function (state) {
    return {
        marketXp: state.contractInfo.market,
    };
};
export var MarketXp = connect(mapState)(_MarketXp);



//////////////////
// WEBPACK FOOTER
// ./src/features/market/MarketXp.tsx
// module id = 2849
// module chunks = 3